module.exports = __webpack_public_path__ + "static/team-photo-cc348be839fe15915f0150abeeba00fd.png";